import ImageBox from "Screens/components/ImageBox";
export default function SysLogo({ image, alt, md}) {
  return (
    <div className={`image ${md ? 'md' : ''}`}>
      <ImageBox image={image} alt={alt} />
    </div>
  );
}
